document.addEventListener('DOMContentLoaded', function () {
      var thumbnails = new Splide('#thumbnail-ingredients-carousel', {
            fixedWidth: 200,
            padding: "5em",
            focus: 'center',
            gap: 10,
            rewind: true,
            pagination: false,
            isNavigation: true,
            arrows: false,
            breakpoints: {
                  640: {
                        fixedWidth: 150,
                        padding: 0,
                  },
            }
      }).mount();

      var main = new Splide('#main-ingredients-carousel', {
            type: 'fade',
            rewind: true,
            pagination: false
      });

      main.sync(thumbnails);
      main.mount();
      thumbnails.mount();


});

